export default "__VITE_ASSET__C4uF34bU__"